import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { KeyValueGrid } from "@/pages/tina/items/components/key-value-grid";
import { PanelShell } from "@/pages/tina/items/components/panel-shell";
import type { PipelineItem, StageExecutionRead } from "@/types/tina";

interface Props {
  item: PipelineItem;
  stages: StageExecutionRead[];
}

interface ErrorPayload {
  type?: string;
  message?: string;
}

export function FailedRetryablePanel({ item, stages }: Props) {
  const latest = [...stages]
    .reverse()
    .find((s) => s.status === "failed_retryable" || s.status === "failed");
  const err = (latest?.error ?? null) as ErrorPayload | null;
  const nextAttempt = item.attempt_count + 1;

  return (
    <PanelShell
      status="failed_retryable"
      subtitle={`Will retry. Attempt ${nextAttempt} of 3 — failing at ${item.current_stage ?? "—"}.`}
    >
      {err ? (
        <Alert>
          <AlertTitle className="font-mono text-xs uppercase tracking-wider">
            {err.type ?? "unknown_error"}
          </AlertTitle>
          <AlertDescription className="whitespace-pre-wrap font-mono text-[13px]">
            {err.message ?? "(no message)"}
          </AlertDescription>
        </Alert>
      ) : (
        <p className="text-sm text-muted-foreground">
          No recent error info available on the stage executions yet.
        </p>
      )}
      <KeyValueGrid
        rows={[
          { label: "Stage", value: item.current_stage ?? "—", mono: true },
          {
            label: "Source",
            value: latest ? `stage_executions attempt ${latest.attempt}` : "—",
          },
          { label: "Next attempt", value: `${nextAttempt} / 3` },
        ]}
      />
    </PanelShell>
  );
}
